import isEmpty from 'lodash/isEmpty';

import { ApolloError } from '@apollo/client';
import { GraphQLError } from 'graphql';

const GRAPHQL_ERROR_REGEXP = /You are editing a stale version/;

// HACK(amir): Quick hack to get rid of the string graphene adds to all errors. Ultimately we'll be sending down
// more structured errors with error codes and translate those to displayable error messages. In the meantime this
// hack would do.

function cleanErrorMessage(error: Error & { graphQLErrors?: Array<Error> }) {
  let { message } = error;

  if (message.match(GRAPHQL_ERROR_REGEXP) && !isEmpty(error.graphQLErrors)) {
    message = message.replace('GraphQL error: ', '');
  }

  return message;
}

export function getFirstGraphQLError(error: Error): GraphQLError | undefined {
  return (error as ApolloError | undefined)?.graphQLErrors?.[0];
}

function getCleanResourceValidationErrorOrDefault(error: GraphQLError) {
  if (error?.extensions == null) {
    return error.message;
  }
  if (error?.extensions.code === 'RESOURCE_VALIDATION_FAILED') {
    if (error.extensions.description) {
      return (error.extensions.description as string).replace?.('Field __all__ is invalid: ', '');
    }
  }
  return error?.extensions.description ?? error.message;
}

export { cleanErrorMessage, getCleanResourceValidationErrorOrDefault };
